import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'
import * as Sentry from '@sentry/react';


export interface AppState {
  selectedPage: string
  selectedPageHistory: string[]
  headerMenuEnabled: boolean
  isKiosk: boolean
}

const initialState: AppState = {
  selectedPage: '/',
  selectedPageHistory: [],
  headerMenuEnabled: true,
  isKiosk: false,
}

export const appSlice = createSlice({
  name: 'app',
  initialState,
  reducers: {
    toggleHeaderMenu: (state, action: PayloadAction<boolean>) => {
      state.headerMenuEnabled = action.payload
    },
    toggleKioskMode: (state, action: PayloadAction<boolean>) => {
      state.isKiosk = action.payload
    },
    setSelectedPage: (state, action: PayloadAction<string | { url: string, addToHistory: boolean }>) => {
      const currentPage = state.selectedPage
      let nextPage = ''
      if (typeof action.payload === 'string') {
        state.selectedPageHistory.push(state.selectedPage)
        state.selectedPage = nextPage = action.payload
      } else {
        if (action.payload.addToHistory) {
          state.selectedPageHistory.push(state.selectedPage)
        }
        state.selectedPage = nextPage = action.payload.url
      }
      Sentry.addBreadcrumb({
        category: 'redirect',
        message: `From page ${currentPage} to page ${nextPage}`,
        level: 'info',
      });
    },
    removeSelectedPageFromHistory: (state) => {
      state.selectedPageHistory = state.selectedPageHistory.slice(0, -1)
    },
    resetSelectedPageHistory: (state) => {
      state.selectedPageHistory = []
    },
  },
})

// Action creators are generated for each case reducer function
export const {
  toggleHeaderMenu,
  toggleKioskMode,
  setSelectedPage,
  removeSelectedPageFromHistory,
  resetSelectedPageHistory,
} = appSlice.actions

export default appSlice.reducer
